// extracted by mini-css-extract-plugin
export var cabinet_item = "dropdown-module--cabinet_item--Xhvi8";
export var logout = "dropdown-module--logout--Y-3to";
export var material_icons = "dropdown-module--material_icons--K9l7q";